var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) {
    raw = strings.slice(0);
} return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
export var OptionLabel = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: var(--riv-spacing-core-8);\n"])));
export var EuFlag = styled.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 16px;\n  height: 16px;\n"])));
